import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { FirebaseTSFirestore } from 'firebasets/firebasetsFirestore/firebaseTSFirestore'; // Assurez-vous que le chemin est correct
//import {firebase} from 'firebase';
import firebase from 'firebase/compat/app'; 
import { Firestore, collection, query, orderBy, limit, startAfter, getDocs, DocumentSnapshot } from '@firebase/firestore';
import { getFirestore } from 'firebase/firestore';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AuthService } from './auth.service';





@Injectable({
  providedIn: 'root'
})

export class UserService {


  constructor(private firestore: AngularFirestore, private authService: AuthService) { 

  }

   // Récupérer les amis suggérés : ceux que l'utilisateur connecté ne suit pas encore
   getSuggestedFriends(currentUserId: string): Observable<any[]> {
   
    return this.firestore.collection('Users').snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          const id = a.payload.doc.id;
          return { id, ...data };
        }).filter(user => user.id !== currentUserId && !user.followers.includes(currentUserId));
      })
    );
  }

  // Suivre un utilisateur en ajoutant son ID dans le tableau followers[] de l'utilisateur courant
  followUser(currentUserId: string, userId: string): Promise<void> {
    const currentUserRef = this.firestore.collection('Users').doc(userId);
    const Myref = this.firestore.collection('Users').doc(currentUserId);
    Myref.update({
      following: firebase.firestore.FieldValue.arrayUnion(userId) // Ajoute l'utilisateur courant dans les followers
    });

    return currentUserRef.update({
      followers: firebase.firestore.FieldValue.arrayUnion(currentUserId) // Ajoute l'utilisateur courant dans les followers
    });
  }

  // Ne plus suivre un utilisateur en retirant son ID du tableau followers[]
  unfollowUser(currentUserId: string, userId: string): Promise<void> {
    const currentUserRef = this.firestore.collection('Users').doc(userId);
    const Myref = this.firestore.collection('Users').doc(userId);

    Myref.update({
      following: firebase.firestore.FieldValue.arrayRemove(userId) // Retire l'utilisateur courant des followers
    });

    return currentUserRef.update({
      followers: firebase.firestore.FieldValue.arrayRemove(currentUserId) // Retire l'utilisateur courant des followers
    });
  }

  // Supprimer un utilisateur de la liste des suggestions
  removeUserFromSuggestions(currentUserId: string, userId: string): Promise<void> {
    const currentUserRef = this.firestore.collection('Users').doc(currentUserId);

    return currentUserRef.update({
      followers: firebase.firestore.FieldValue.arrayRemove(userId) // Retire l'utilisateur suggéré du tableau following
    });
  }

}
